import * as React from "react";
import styled from "@emotion/styled";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import SnackBarContext, { initSnackBarStore, snackBarInitialState } from "@/contexts/SnackBar";
import breakpoint from "@/utils/breakpoint";

const Container = styled.div`
  width: 75%;
  padding: 15px;
  position: fixed;
  bottom: -200%;
  left: 50%;
  z-index: 101;
  transform: translate(-50%, 0);
  transition: all 0.3s;
  min-height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #1976d2;
  border-radius: 4px;
  border: 1px solid #ededed;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14),
    0px 1px 18px 0px rgba(0, 0, 0, 0.12);

  &.info {
    background-color: #efefef;
  }

  &.warn {
    background-color: #ff9800;
  }

  &.alert {
    background-color: #d3302f;
  }

  &.on {
    bottom: 50px;
  }

  ${breakpoint.lessThan("md")`
    width: 90%;
  `}
`;

const Card = styled.p`
  font-size: 15px;
  font-weight: bold;
  line-height: 1.43;
  text-align: left;
  color: #fff;
`;

const SnackBarCard = () => {
  const {
    card: { open, message, mode },
  } = React.useContext(SnackBarContext) || initSnackBarStore(snackBarInitialState);
  return (
    <Container
      className={classNames({
        on: open,
        info: mode === "info",
        warn: mode === "warn",
        alert: mode === "alert",
      })}
    >
      <Card>
        <FontAwesomeIcon icon={faExclamationCircle} /> {message}
      </Card>
    </Container>
  );
};

export default SnackBarCard;
